// Charge la base commune
import './common.js'

// actions principales communes à toutes les pages
$(document).ready(function () {
  // gestion des documents à DL
  $('.doc-section').waypoint(function () {
    import(/* webpackChunkName: "docSection", webpackPrefetch: true */ './scss/components/docSection.scss').then(() => {
      /* global Waypoint */
      Waypoint.refreshAll()
    })
    this.destroy()
  }, {
    offset: '100%'
  })
})
